import { https } from './https';
import { api_url } from '../Configuration/config';

//get loggedin admin profile info
export async function getStatuses(modelName){
    return await https.get(`${api_url}admin/status?model=${modelName}`);
}

